import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme) =>
    createStyles({
        messagesSection: {
            [theme.breakpoints.down('sm')]: {
                padding: '0 15px 0 15px',
            },
            width: '100%'
        },
        buttonContainer: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
        },
        commentsList: {
            listStyleType: 'none',
            padding: '0px',
        },
        commentDiv: {
            margin: '15px 0 15px 0'
        },
        commentSeparator: {
            marginBottom: '15px !important'
        },
        imageContainer: {
            margin: '15px 0px 0px',
            '& ul': {
                margin: '0px',
                padding: '0px',
                listStyleType: 'none',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
                alignItems: 'center',

                '& li': {
                    minWidth: '150px',
                    width: 'calc(25% - 15px)',
                    height: '100px',
                    marginBottom: '15px',
                    overflow: 'hidden',
                    border: '1px solid #d0dbe4',
                    '& button': {
                        margin: '0px',
                        padding: '0px',
                        border: 'none',
                        backgroundColor: 'transparent',
                        borderRadius: '0px',
                        width: '100%',
                        height: '100%'
                    },
                    '& img': {
                        objectFit: 'contain',
                        height: '100%',
                    }
                }
            }
        }
    }),
);

export default useStyles;